import styled from '@emotion/styled';

const Hero = styled('div')({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
});

export default Hero;
